import history from './history.js';
import jwtDecode from 'jwt-decode';
import mainConfig from '../../app/containers/Productionline/productionConfig';

const localStorage = global.window.localStorage;
const configuration = mainConfig.components;
const auth = {
  getToken() {
    return localStorage.getItem('token');
  },

  getRefreshToken() {
    return localStorage.getItem('refresh');
  },

  registerSession(username, accessToken) {
    const sessionUuid = sessionStorage.getItem('session_uuid');
    if (!sessionUuid || !username || !accessToken) return;
    fetch('/api/v1/vnc/xlamclients/terminalPing/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({
        ip: '',
        user: username,
        session_uuid: sessionUuid,
        is_default: sessionStorage.getItem('is_default_session') === 'true'
      })
    }).catch(() => {});
  },

  async login(username, password) {
    // const token = auth.getToken();
    try {
      const response = await fetch('/api/v1/auth/login/', {
        method: 'POST',
        body: JSON.stringify({
          username,
          password
        }),
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      });
      let promise;
      if (response.status == 200) {
        promise = new Promise((resolve) => {
          response.json().then((json) => {
            localStorage.setItem('token', json.access);
            localStorage.setItem('refresh', json.refresh);
            const decoded_token = jwtDecode(json.access);
            auth.registerSession(username, json.access);
            resolve({ response, token: decoded_token });
          });
        });
      } else {
        console.log('ERROR login: ', response.status);
        promise = Promise.resolve({ response, token: null });
      }
      return await promise;
    } catch (error) {
      // eslint-disable-next-line no-undef
      return await Promise.resolve({ response: response || { status: 600 }, token: null });
    }
  },

  async reload(storageToken, setLoginData, initiateLogin, setAuthState, setCurrentUser, currentUser) {
    try {
      const response = await fetch('/api/v1/auth/all/get_user/', {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${storageToken}`
        })
      });
      let promise;
      if (response.status == 200) {
        promise = new Promise((resolve) => {
          response.json().then(async (json) => {
            try {
            } catch (e) {
              console.log('exception', e);
            }
            setCurrentUser({ ...json });
            setLoginData(json);
            const prodLineSize = configuration.reduce((count, item) => count + item.length, 0);
            if (!localStorage.getItem('settings')) {
              const settingsData = Array.from({ length: prodLineSize }, () => true);
              localStorage.setItem('settings', JSON.stringify(settingsData));
            } else {
              if (prodLineSize !== JSON.parse(localStorage.getItem('settings')).length) {
                const settingsData = Array.from({ length: prodLineSize }, () => true);
                localStorage.setItem('settings', JSON.stringify(settingsData));
              }
            }
          });
        });
      } else {
        auth.logout('reload response != 200');
        promise = Promise.resolve(false);
      }
      return await promise;
    } catch (error) {
      return await Promise.resolve(false);
    }
  },

  async refreshToken() {
    const refresh = localStorage.getItem('refresh');
    if (!refresh) {
      return { success: false, type: 'logout' };
    }

    try {
      const response = await fetch('/api/v1/auth/token_refresh/', {
        method: 'POST',
        body: JSON.stringify({ refresh }),
        headers: new Headers({
          'Content-Type': 'application/json'
          // no need to authorize for refresh
          // Authorization: `Bearer ${token}`
        })
      });

      if (response.status === 200) {
        const json = await response.json();
        localStorage.setItem('token', json.access);
        if (json.refresh) localStorage.setItem('refresh', json.refresh);
        return true;
      }
      if (response.status === 400) {
        auth.logout('refresh response 400');
        return { success: false, type: 'logout' };
      }

      auth.logout('refresh server down');
      return { success: false, type: 'server-down' };
    } catch {
      return { success: false, type: 'server-down' };
    }
  },

  async verifyToken() {
    console.log('## verifyToken ##');
    try {
      const response = await fetch('/api/v1/auth/login-token-verify/', {
        method: 'POST',
        body: JSON.stringify({
          token: `${auth.getToken()}`
        }),
        headers: new Headers({
          'Content-Type': 'application/json'
        })
      });
      let promise;
      if (response.status == 200) {
        promise = new Promise((resolve) => {
          response.json().then((json) => {
            resolve(json);
          });
        });
      } else if (response.status == 400) {
        auth.logout('verify response 400');
        promise = Promise.resolve({
          success: false,
          type: 'logout'
        });
      } else {
        auth.logout('verify server down');
        promise = Promise.resolve({
          success: false,
          type: 'server-down'
        });
      }
      return await promise;
    } catch (error) {
      return await Promise.resolve({
        success: false,
        type: 'server-down'
      });
    }
  },

  logout(sender) {
    const sessionUuid = sessionStorage.getItem('session_uuid');
    const token = localStorage.getItem('token');
    if (sessionUuid && token) {
      fetch('/api/v1/vnc/terminal-sessions/close_session/', {
        method: 'POST',
        body: JSON.stringify({ session_uuid: sessionUuid }),
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        })
      }).catch(() => {});
    }
    localStorage.removeItem('token');
    localStorage.removeItem('refresh');
    localStorage.removeItem('settings');
    localStorage.removeItem('userView');
    history.push('/login');
    return Promise.resolve(true);
  },

  loggedIn() {
    // 'token', 'refresh' cleared on logout
    return !!localStorage.getItem('token') && !!localStorage.getItem('refresh');
    // return !!localStorage.token;
  }
};

export default auth;
